/**
 * Wohnungs-Detailseite – Eckdaten auf Mobile ein-/ausklappen
 * und PDF-Download mit Ladezustand.
 *
 * Markup: template-parts/wohnung/detail.php
 *   Button `.js-wohnung-facts-toggle` steuert die `<dl class="wohnung--facts">`
 *   per `aria-controls`. Sichtbar/eingeklappt nur ≤ 760px (siehe _wohnung.scss).
 *   Link `.js-ks-pdf` holt die Broschüre per fetch, damit der Spinner sichtbar
 *   bleibt, bis die Datei fertig ist.
 */
document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.js-wohnung-facts-toggle');
    if (toggle) {
        var id = toggle.getAttribute('aria-controls');
        var facts = id ? document.getElementById(id) : null;
        if (!facts) {
            return;
        }

        var open = facts.getAttribute('data-open') === 'true';
        facts.setAttribute('data-open', open ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        toggle.classList.toggle('is-open', !open);
        return;
    }

    var pdfLink = event.target.closest('.js-ks-pdf');
    if (!pdfLink || event.defaultPrevented) {
        return;
    }
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
    }
    if (pdfLink.getAttribute('target') === '_blank') {
        return;
    }
    if (pdfLink.classList.contains('is-loading')) {
        event.preventDefault();
        return;
    }

    event.preventDefault();
    downloadWohnungPdf(pdfLink);
});

function downloadWohnungPdf(link) {
    var href = link.href;
    if (!href) {
        return;
    }

    setPdfLoading(link, true);

    fetch(href, { credentials: 'same-origin' })
        .then(function (res) {
            if (!res.ok) {
                throw new Error('pdf');
            }
            var type = (res.headers.get('content-type') || '').toLowerCase();
            if (type.indexOf('pdf') === -1 && type.indexOf('octet-stream') === -1) {
                throw new Error('pdf');
            }
            var filename = filenameFromDisposition(res.headers.get('content-disposition')) || 'beisler.pdf';
            return res.blob().then(function (blob) {
                saveBlob(blob, filename);
            });
        })
        .catch(function () {
            window.location.assign(href);
        })
        .then(function () {
            setPdfLoading(link, false);
        });
}

function setPdfLoading(link, on) {
    link.classList.toggle('is-loading', on);
    link.setAttribute('aria-busy', on ? 'true' : 'false');
    if (on) {
        link.setAttribute('aria-disabled', 'true');
    } else {
        link.removeAttribute('aria-disabled');
    }
}

function filenameFromDisposition(header) {
    if (!header) {
        return '';
    }
    var star = header.match(/filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i);
    if (star) {
        try {
            return decodeURIComponent(star[1].replace(/["']/g, '').trim());
        } catch (e) {
            return star[1].replace(/["']/g, '').trim();
        }
    }
    var plain = header.match(/filename\s*=\s*("?)([^";]+)\1/i);
    return plain ? plain[2].trim() : '';
}

function saveBlob(blob, filename) {
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () {
        URL.revokeObjectURL(url);
    }, 2000);
}
